// extracted by mini-css-extract-plugin
export var children = "Layout-module--children--2f361";
export var main = "Layout-module--main--8841c";